<template>
  <Form :label-width="150" @submit.native.prevent>
    <FormItem :label="$t('label.country')">
      <Select v-model="transform.country" :disabled="readonly">
        <Option v-for="c in options.countries" :key="c" :value="c">{{$t(`country-name.${c}`)}}</Option>
      </Select>
    </FormItem>
    <FormItem :label="$t('action.format_to')">
      <Select v-model="transform.formatter" :disabled="readonly">
        <Option v-for="f in options.formatters" :key="f" :value="f">{{$t(`phonenumber-formatter.${f}`)}}</Option>
      </Select>
    </FormItem>
  </Form>
</template>

<script>
  export default {
    props: [ 'transform', 'options', 'readonly' ]
  }
</script>
